import React, { useState } from 'react'
import classnames from 'classnames'

import '../styles/why.scss'

function Why() {
  const [isToggled, setToggled] = useState(false)
  
  const handleToggleClick = event => {
    setToggled(!isToggled)
  }

  return (
    <div className="account-why">
      <button className="account-title" type="button" onClick={handleToggleClick}>Зачем нужна подписка?</button>
      <div className={classnames('account-why__inner', { 'hidden': !isToggled })}>
        <p className="account-why__text">После покупки подписки вы&nbsp;сможете без ограничений слушать все-все лекции у&nbsp;нас на&nbsp;сайте, а&nbsp;также все курсы, подкасты и&nbsp;другие аудиоматериалы&nbsp;&mdash; в&nbsp;нашем мобильном приложении &laquo;Радио Arzamas&raquo;.</p>
        <p className="account-why__text">А&nbsp;еще у&nbsp;нас есть отдельное приложение для детей&nbsp;&mdash; &laquo;Гусьгусь&raquo;! Подписку на&nbsp;него тоже можно купить прямо здесь. Общая подписка на&nbsp;два приложения стоит дешевле двух отдельных.</p>
      </div>
    </div>
  )
}

export default React.memo(Why)
